module.exports = __webpack_public_path__ + "static/media/video-en.2d736d9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-en.mp4
// module id = otPv
// module chunks = 1